import {connect} from '@modifi/redux'
import {selectExtraLinks} from '../../../../../data/navigation'

import LoginButton, {LoginButtonProps} from './LoginButton'

const mapStateToProps = (state: Record<string, any>): Pick<LoginButtonProps, 'loginUrl'> => ({
  loginUrl: selectExtraLinks(state)?.login,
})

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(LoginButton)
